module.exports = __webpack_public_path__ + "img/icon_map_car.80ee4f4a.png";